import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {CoachInfoCard} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {getDateUtilDefaultInstance} from '/util/date.util';

import {styles} from './ExpiringCoachRenewalsReportContent.style';

interface Props {
  tt: (key: string, fallback: string) => string;
  recordData: {
    licenseExpiresOn: string;
    frontlineCoachesCount: number;
    frontlineClientsCount: number;
  };
}

export const ExpiringCoachRenewalsReportContent: React.FC<Props> = ({
  tt,
  recordData,
}) => {
  const {licenseExpiresOn, frontlineCoachesCount, frontlineClientsCount} =
    recordData;

  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">{tt('title', 'Coach Renewal')}</Text>
        </Gutter>
      </View>

      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('renewalExpires', 'Renewal Expires')}</Text>}
          suffix={
            <Text variant="button">
              {getDateUtilDefaultInstance().formatDate(
                licenseExpiresOn,
                'MMMM d, yyyy',
              )}
            </Text>
          }
          testID={CoachInfoCard.renewalExpiresContent}
        />
      </Gutter>

      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('frontlineCoaches', 'Frontline Coaches')}</Text>}
          suffix={<Text variant="button">{frontlineCoachesCount}</Text>}
          testID={CoachInfoCard.frontlineCoachesContent}
        />
      </Gutter>

      <Gutter>
        <ListItem
          style={{base: styles.listItem}}
          readonly
          label={<Text>{tt('frontlineClients', 'Frontline Clients')}</Text>}
          suffix={<Text variant="button">{frontlineClientsCount}</Text>}
          testID={CoachInfoCard.frontlineClientsContent}
        />
      </Gutter>
    </View>
  );
};

export default withTranslation('reportCardContent.expiringCoachRenewals')(
  ExpiringCoachRenewalsReportContent,
);
